// Deep-link builder for the Manifest Line Items grid, co-located with that
// route. Callers (e.g. the waste-stream drawer's "Review" entry point) used to
// hand-build the omnisearch query string; if the route renamed a facet or
// changed the operator grammar, those links silently filtered wrong with no
// compile-time signal. Centralizing the path + query here — and sharing
// `UNRESOLVED_DISCREPANCY_COUNT_FIELD` with the grid's own column definition —
// keeps every link in step with what the route actually parses.

/**
 * Omnisearch facet the Manifest Line Items grid filters unresolved
 * discrepancies on. Imported by both the grid column definition and the
 * link builder below so a rename updates both at once.
 */
export const UNRESOLVED_DISCREPANCY_COUNT_FIELD = "unresolvedDiscrepancyCount" as const;

/**
 * Path + omnisearch for the Manifest Line Items grid scoped to a single waste
 * stream's unresolved discrepancies.
 */
export const buildWasteStreamDiscrepanciesPath = ({
  tenantId,
  wasteStreamId,
}: {
  tenantId: string;
  wasteStreamId: string;
}): string => {
  const query = `tenantId:${tenantId} wasteStreamId:${wasteStreamId} ${UNRESOLVED_DISCREPANCY_COUNT_FIELD}:>0`;
  return `/o/${tenantId}/waste/manifest-line-items?omnisearch=${encodeURIComponent(query)}`;
};
